import script from "./EmailPreview.vue?vue&type=script&lang=ts&setup=true"
export * from "./EmailPreview.vue?vue&type=script&lang=ts&setup=true"

import "./EmailPreview.vue?vue&type=style&index=0&id=031dbbda&lang=scss&scoped=true"
/* custom blocks */
import block0 from "./EmailPreview.vue?vue&type=custom&index=0&blockType=i18n&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "C:\\Jenkins\\workspace\\tformCommunicationViewer_develop\\frontend\\.yarn\\__virtual__\\vue-loader-virtual-12f41bf58f\\5\\YarnPackageCache\\vue-loader-npm-17.0.0-6ebaa2d3c5-a6eb675f07.zip\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-031dbbda"]])

export default __exports__